<template>
  <el-dialog title='添加结算' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='700px'>
    <el-form :model='form' label-width='130px' label-position='right' :rules='rules'
             ref='ruleForm' class='settlement-form'>
      <el-form-item label='结算类型：' prop='type' style='margin-top: 15px'>
        <el-select v-model='form.type' filterable size='mini' placeholder='请选择结算类型'
                   value-key='settlementTypeId'>
          <el-option v-for='item in settlementTypeArr' :label='item.label'
                     :value='item.value' :key='item.value'></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label='结算方式：' prop='settType' style='margin-top: 15px'>
        <el-checkbox-group v-model="form.settType" @change="getType">
          <el-checkbox :label="0" :disabled="disabled1" @change="selectType1">合同价</el-checkbox>
          <el-checkbox :label="1" :disabled="disabled2" @change="selectType">预结算价</el-checkbox>
          <el-checkbox :label="2" v-if="importShow">预估价</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label='合同：' prop='contract'>
        <el-select v-model="form.contract" filterable style="width: 100%" size="small"
                   placeholder="请选择合同" value-key="id" @change="handleChangeContract">
          <el-option
            v-for="item in contractOption" :key="item.id" :label="item.contractName"
            :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label='合同编号' prop='codeNumber'>
        <el-input v-model='form.codeNumber' size='mini' :disabled="true"></el-input>
      </el-form-item>
      <el-form-item :label='form.type === "1" ? "装车税率：" : "税率："' prop='taxRate'>
        <el-input v-model='form.taxRate' type='number' size='mini'></el-input>
      </el-form-item>
      <el-form-item :label='form.type === "1" ? "装车含税单价：" : "含税单价："' prop='taxPreparePrice'>
        <el-input v-model='form.taxPreparePrice' type='number' size='mini'></el-input>
        <div class='settlement-tips'>*注意：此单价为每台车价格</div>
      </el-form-item>
      <el-form-item v-if='form.type === "1"' label='卸车税率：' prop='unloadTaxRate'>
        <el-input v-model='form.unloadTaxRate' type='number' size='mini'></el-input>
      </el-form-item>
      <el-form-item v-if='form.type === "1"' label='卸车含税单价：' prop='unloadPrice'>
        <el-input v-model='form.unloadPrice' type='number' size='mini'></el-input>
        <div class='settlement-tips'>*注意：此单价为每台车价格</div>
      </el-form-item>
      <el-form-item>
        <div class='flex-center-center mt10'>
          <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'> 添加
          </el-button>
          <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {
  addSpecialGenerateSettlement,
  addSpecialSettlement,
  contractPageList
} from '@/service/financial';

  export default {
    name: 'index',
    data() {
      return {
        dialogVisible: false,
        isImport: null,
        defaultForm: {},
        form: {
          infoList: [],
          type: '',
          settType: [],
          contract: '',
          taxRate: '',
          codeNumber: '',  // 合同编号
          taxPreparePrice: '',
          unloadTaxRate: '',
          unloadPrice: '',
        },
        formData: [],
        importShow: false,
        disabled1: false,
        disabled2: false,
        typeName: [],
        type: [],
        contractOption: [],
        rules: {
          type: [
            {
              required: true,
              message: '请选择结算类型',
              trigger: 'blur',
            },
          ],
          settType: [
            {
              required: true,
              message: '请选择结算方式',
              trigger: 'blur',
            },
          ],
          taxRate: [
            {
              required: true,
              message: '请输入税率',
              trigger: 'blur',
            },
          ],
          taxPreparePrice: [
            {
              required: true,
              message: '请输入含税单价',
              trigger: 'blur',
            },
          ],
          contract: [
            {
              required: true,
              message: '请选择合同',
              trigger: 'blur',
            },
          ],
          unloadTaxRate: [
            {
              required: true,
              message: '请输入卸车税率',
              trigger: 'blur',
            },
          ],
          unloadPrice: [
            {
              required: true,
              message: '请输入卸车含税单价',
              trigger: 'blur',
            },
          ],
        },
        submitLoading: false,
        settlementTypeArr: [{
          label: '委托商-托运费',
          value: '0',
        },
        //   {
        //   label: '委托商-港口费',
        //   value: '1',
        // }
        ],
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      handleChangeContract(val) {
        console.log(val);
        this.form.codeNumber = val.codeNumber;
      },
      //查询合同
      async _contractPageList() {
        let obj = {
          consignorId: this.form.consignorId,
        };
        let res = await contractPageList(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractOption = res.data;
      },
      /**
       * 打开弹出框
       * @param selectTable 当前选中数据
       */
      dialogOpen(isImport, selectTable,id,consignorName,batchNumber,waybillNumber,
                 frameNumber,brandId,brandName,departurePlace,arrivePlace,stringDate) {
        this.isImport = isImport;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.form.infoList = selectTable;
        this.form.consignorId = id.toString()
        this.form.consignorName = consignorName.toString()
        this.form.batchNumber = batchNumber.toString()
        this.form.waybillNumber = waybillNumber.toString()
        this.form.frameNumber = frameNumber.toString()
        this.form.brandId = brandId.toString()
        this.form.brandName= brandName.toString()
        this.form.departurePlace = departurePlace.toString()
        this.form.arrivePlace = arrivePlace.toString()
        this.form.stringDate = stringDate.toString()
        this._contractPageList(id)
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
        this.form = {}
        this.disabled1 = false
        this.disabled2 = false
        this.importShow = false
        this.submitLoading = false
      },
      selectType(){
        if (this.form.settType.includes(1) || this.form.settType.includes(2)) {
          this.disabled1 = true;
          this.importShow = true
        } else {
          this.disabled1 = false;
          this.importShow = false
        }
      },
      selectType1(){
        if (this.form.settType.includes(0)) {
          this.disabled2 = true;
        }else {
          this.disabled2 = false;
        }
      },
      getType(){
        this.type = this.form.settType.reduce((acc, value) => {
          switch (value) {
            case 0:
              acc += 0;
              break;
            case 1:
              acc += 1;
              break;
            case 2:
              acc += 2;
              break;
            default:
              break;
          }
          return acc;
        }, 0);
        if (this.form.settType.includes(1) && this.form.settType.includes(2)) {
          this.type = 4;
        }
        this.typeName = this.form.settType.map(value => {
          switch(value) {
            case 0:
              return "合同价";
            case 1:
              return "预结算价";
            case 2:
              return "预估价";
            default:
              return "";
          }
        });
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.submitLoading = true;
            let {
              contract
            } = this.form
            const data = await addSpecialGenerateSettlement({
              // infoList: this.form.infoList,
              id: this.isImport == 0 ? this.form.infoList.map(item => item.id).join(',') : this.isImport == 1? this.form.infoList.map(item => item.planCarId).join(',') : '',
              type: this.form.type,
              settType: this.type,
              taxRate: this.form.taxRate,
              taxPreparePrice: this.form.taxPreparePrice,
              unloadPrice: this.form.unloadPrice,
              unloadTaxRate: this.form.unloadTaxRate,
            });
            if (data.status !== 0) return this.$message.warning(data.message);
            this.formData = data.data
            const res = await addSpecialSettlement({
              id: this.formData,
              consignorId: this.form.consignorId,
              consignorName: this.form.consignorName,
              batchNumber: this.form.batchNumber,
              waybillNumber: this.form.waybillNumber,
              frameNumber: this.form.frameNumber,
              brandId: this.form.brandId,
              brandName: this.form.brandName,
              departurePlace: this.form.departurePlace,
              arrivePlace: this.form.arrivePlace,
              stringDate: this.form.stringDate,
              types: this.form.type,
              type: this.form.settType.join(','),
              typeName: this.typeName.join(','),
              contractId: contract.id,
              contractName: contract.contractName,
              taxRate: this.form.taxRate,
              taxContractPrice: this.form.taxPreparePrice,
              unloadPrice: this.form.unloadPrice,
              unloadTaxRate: this.form.unloadTaxRate,
              state: 0})
            this.submitLoading = false;
            if (res.status !== -1) return this.$message.warning(res.message);
            this.$message.success(res.message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
    },
  };
</script>

<style lang='scss' scoped>
  .settlement-form {
    width: 70%;
    margin: 0 auto;
  }

  .settlement-tips {
    margin-top: -15px;
    position: absolute;
    right: 0;
    font-size: 12px;
    color: #F56C6C;
  }

  .el-select {
    width: 100%;
  }
</style>
